import React from 'react';
import styled from 'styled-components';

const StyledImg = styled.img`
    width: ${({ logo }) => (logo ? '50px' : '100%')};
    height: ${({ logo }) => (logo ? '50px' : '100%')};
`;

const Image = ({ url, logo }) => {
    return (
        <StyledImg src={url} logo={logo} />
    );
};

export default Image;
